import script from "./switch-contact-lookup.vue?vue&type=script&setup=true&lang=ts"
export * from "./switch-contact-lookup.vue?vue&type=script&setup=true&lang=ts"

import "./switch-contact-lookup.vue?vue&type=style&index=0&id=5760ac95&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5760ac95"]])

export default __exports__